import { FC } from 'react'

// interface DDPrimeProps {}

const Earn: FC = () => {
  return <div className="flex lg:px-96 px-12 lg:py-24 py-12 gap-16">EMPTY</div>
}

export default Earn
